import { Provider } from "react-redux";

import { createRoot } from "react-dom/client";

import App from "./App.jsx";
import store from "./app/store.js";
import { initSentry, reactErrorHandler, SentryErrorBoundary } from "./config/sentry";

import "./styles/global.css";
import "./styles/variables.css";
import "./styles/variables.scss";
import "./styles/mixins.scss";

import "@ino-ui/tv/dist/styles.css";
import "./styles/index.css";

import { HashRouter } from "react-router-dom";

initSentry();

const SentryFallback = () => (
  <div
    style={{
      padding: "20px",
      color: "white",
      background: "#1a1a1a",
    }}
  >
    <h2>Something went wrong</h2>
    <p>The application encountered an error. Please restart the app.</p>
  </div>
);

createRoot(document.getElementById("root"), {
  onRecoverableError: reactErrorHandler(),
}).render(
  <SentryErrorBoundary fallback={SentryFallback}>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </SentryErrorBoundary>
);
